import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sku",
  "use": "icon-sku-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sku\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 554.656h341.344V128H128v426.656zM128 896h341.344v-256H128v256z m426.656 0H896V469.344H554.656V896z m0-768v256H896V128H554.656z\" fill=\"#929EAA\" p-id=\"3437\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sku.svg
// module id = 9Ro6
// module chunks = 112